import styled from 'styled-components'
import { Box, Flex, Input, getPaletteColor } from 'pcln-design-system'

const DatePickerWrap = styled(Flex)`
  border: 1px solid transparent;
  width: 100%;
  box-shadow: 0 0 0 2px transparent;
  border-radius: ${(props) => props?.theme?.borderRadii?.lg};
  box-shadow: ${(props) =>
    props.isFocused ? `0 0 0 2px ${getPaletteColor('primary.base')(props)}` : 'none'};

  ${(props) =>
    props.theme.mediaQueries &&
    `${props.theme.mediaQueries.md} {
    position: relative;
  }`}
`
const CalendarCloseBanner = styled(Flex)`
  position: fixed;
  top: 0px;
  left: 0;
  z-index: 11;
  height: 60px;
  width: 100%;
  ${(props) => props.theme.mediaQueries.md} {
    display: none;
  }
`
const CalendarContainer = styled(Box)`
  z-index: 10;
  position: fixed;
  top: 60px;
  right: 0px;
  width: 100%;
  ${(props) => `
      ${props.theme.mediaQueries.md} {
        position: absolute;
        top: 50px;
        background: blue;
        width: initial;

      }
    `}
`

const StyledInput = styled(Input)`
  box-shadow: none !important;
  border: none !important;
  padding-left: 36px;
  width: 100%;
  padding-top: 14px;
`

const InputWrap = styled(Box)`
  height: 44px;
  width: 100%;
`

const FlexDatesBox = styled(Box)`
  display: none;
  position: absolute;
  bottom: -34px;
  left: 0;

  ${(props) =>
    props.theme.mediaQueries &&
    `${props.theme.mediaQueries.md} {
    display: block;
  }`}
`

export { FlexDatesBox, InputWrap, StyledInput, CalendarContainer, CalendarCloseBanner, DatePickerWrap }
